var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "14px",
    viewBox: "0 0 9 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-403.000000, -757.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(392.601769, 748.924994)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.500000, 8.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.09658008,10.7020023 L3.28019741,6.67695129 L8.13751933,2.26321821 C8.66876634,1.78013503 8.70826068,0.957496874 8.2251775,0.425768228 C7.74209431,-0.10547878 6.91993779,-0.144973118 6.38820915,0.337628425 L0.425527408,5.75654056 C-0.105719599,6.23962374 -0.144732299,7.06178026 0.338350882,7.59350891 C0.400963857,7.66286482 0.470319767,7.72355124 0.543047145,7.77653145 C0.554606464,7.78616422 0.564239229,7.7972419 0.576280186,7.80639302 L6.42866676,12.6979113 C6.67237572,12.900681 6.96761998,12.9998985 7.2623826,12.9998985 C7.63420734,12.9998985 8.00362389,12.8409578 8.26081873,12.5336726 C8.72126491,11.9821968 8.64805589,11.1624485 8.09658008,10.7020023"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.493549d536993d6f157fe4bdbc8b9a8b.svg";
export { ForwardRef as ReactComponent };